<template lang="pug">
.pretty-picture
  ParamsWindow(:goThere="goThere('m31')", :reset="reset('m31')", :params="params.m31", title="M31", :filters="['I', 'R', 'G', 'Ha']", :isOpen.sync="paramsWindow.m31.isOpen")
  ParamsWindow(:goThere="goThere('m42')", :reset="reset('m42')", :params="params.m42", title="M42", :filters="['Y', 'I', 'G']", :isOpen.sync="paramsWindow.m42.isOpen")
  ParamsWindow(:goThere="goThere('m45')", :reset="reset('m45')", :params="params.m45", title="M45", :filters="['Y', 'I', 'R', 'G']", :isOpen.sync="paramsWindow.m45.isOpen")
  ParamsWindow(:goThere="goThere('m101')", :reset="reset('m101')", :params="params.m101", title="M101", :filters="['-']", :isOpen.sync="paramsWindow.m101.isOpen")
  ParamsWindow(:goThere="goThere('perseus')", :reset="reset('perseus')", :params="params.perseus", title="Perseus Cluster", :filters="['I', 'R', 'G']", :isOpen.sync="paramsWindow.perseus.isOpen")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { PrettyPictureLayerModule } from "./";
import { FrameStore } from "@/modules/base";
import ParamsWindow from "./ParamsWindow.vue";
import { defaultParams } from '@/modules/layers/PrettyPictureLayer/defaultParams';
import { store } from '@/store';
import { EquatorialCoord } from '@hscmap/angle';
import * as easing from '@hscmap/easing'

@Component({
  components: { ParamsWindow },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: PrettyPictureLayerModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof PrettyPictureLayerModule>

  get params() {
    return this.frameStore.params
  }

  get paramsWindow() {
    return this.frameStore.paramsWindow
  }

  reset(key: keyof ReturnType<typeof defaultParams>) {
    return () => {
      this.params[key] = defaultParams()[key]
    }
  }

  goThere(key: keyof ReturnType<typeof defaultParams>) {
    return () => {
      const view = this.params[key].view
      const { a, d } = view
      const coord = EquatorialCoord.fromRad(a, d)
      console.log({ coord })
      store.currentGlobe().viewFactory.jumpTo(view, { coord, easingFunction: easing.slowStartStop4, duration: 4000 })
    }
  }
}
</script>
